import React from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import ProtectedRoute from "./auth/components/ProtectedRoute";
import Home from "./Home";
import ErrorBoundary from "./common/components/ErrorBoundary";
import { Login } from "auth/components/Login";

const App: React.FC = () => {
  return (
    <React.Fragment>
      <Router>
        <ErrorBoundary>
          <Switch>
            <Route path="/login" component={Login} />
            <Route path="/:domain/login" component={Login} />
            <ProtectedRoute path="/" Component={<Home />} />
          </Switch>
        </ErrorBoundary>
      </Router>
    </React.Fragment>
  );
};

export default App;
